import React from 'react'
import { oneOf, bool, string } from 'prop-types'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'
import { track } from '../../util'

const Container = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 71px;
  margin: 0;
  ${p => {
    let backgroundColor
    let borderBottom

    if (p.loggedIn && p.mode !== 'dark') {
      backgroundColor = vars.grayDark
      borderBottom = 0
    } else {
      backgroundColor = 'white'
      borderBottom = `1px solid ${vars.grayLighter}`
    }

    return `
      background-color: ${backgroundColor};
      border-bottom: ${borderBottom};
    `
  }};

  img {
    position: relative;
    left: 24px;
    width: 200px;
    height: 23px;
  }

  img.lightText {
    display: ${p => (p.loggedIn && p.mode !== 'dark' ? 'block' : 'none')};
  }

  img.darkText {
    display: ${p => (!p.loggedIn || p.mode === 'dark' ? 'block' : 'none')};
  }

  @media screen and (max-width: ${vars.screenMd}) {
    background-color: white;
    border-bottom: 1px solid ${vars.grayLighter};

    img.lightText {
      display: none;
    }

    img.darkText {
      display: block;
    }
  }

  @media screen and (max-width: ${vars.screenSm}) {
    padding: 0;
  }
`

const Logo = ({ loggedIn, mode }, { rootUrl }) => (
  <Container
    href={rootUrl || ''}
    loggedIn={loggedIn}
    mode={mode}
    onClick={() => {
      track({ event: 'logoClick' })
    }}
  >
    <img
      src="https://public-assets.labelinsight.com/images/logo_white_text_2x.png"
      className="lightText"
      alt="Label Insight"
    />
    <img
      src="https://public-assets.labelinsight.com/images/logo_black_text.png"
      className="darkText"
      alt="Label Insight"
    />
  </Container>
)

Logo.propTypes = {
  loggedIn: bool.isRequired,
  mode: oneOf(['light', 'dark', 'auto']),
}

Logo.contextTypes = {
  rootUrl: string,
}

export default Logo



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Logo.js